export default function getIsSendTransactionErrorUnexpected(e) {
  return !(
    e.code === 4001 || // MetaMask
    e.code === -32002 ||
    // e.code === -32603 || // MetaMask mobile (iPhone)
    e === 'transaction was cancelled by user' || // Status
    e.message &&
      [
        'User denied',
        'User canceled', // Trust WalletConnect
        'cancelled', // Trust
        'User rejected',
        'Rejected by user', // Gnosis
        'Actions cancelled', // imToken
        'User closed modal', // WalletConnect
      ].some(message => e.message.toLowerCase().includes(message.toLowerCase())) || e.stack?.includes('User denied transaction') // MetaMask
  );
}
